"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Icons;
(function (Icons) {
    Icons["arrow"] = "arrow";
    Icons["arrowUp"] = "arrowUp";
    Icons["check"] = "check";
    Icons["close"] = "close";
    Icons["delete"] = "delete";
    Icons["domain"] = "domain";
    Icons["eye"] = "eye";
    Icons["hamburger"] = "hamburger";
    Icons["plus"] = "plus";
    Icons["minus"] = "minus";
    Icons["more"] = "more";
    Icons["notification"] = "notification";
    Icons["notificationOff"] = "notificationOff";
    Icons["user"] = "user";
    Icons["team"] = "team";
    Icons["support"] = "support";
    Icons["report"] = "report";
    Icons["sort"] = "sort";
    Icons["target"] = "target";
    Icons["gear"] = "gear";
})(Icons = exports.Icons || (exports.Icons = {}));
var FieldErrorType;
(function (FieldErrorType) {
    FieldErrorType[FieldErrorType["none"] = 0] = "none";
    FieldErrorType[FieldErrorType["validation"] = 1] = "validation";
    FieldErrorType[FieldErrorType["submit"] = 2] = "submit";
})(FieldErrorType = exports.FieldErrorType || (exports.FieldErrorType = {}));
var GrantType;
(function (GrantType) {
    GrantType["password"] = "password";
    GrantType["refreshToken"] = "refresh_token";
})(GrantType = exports.GrantType || (exports.GrantType = {}));
var CookiesType;
(function (CookiesType) {
    CookiesType["token"] = "token";
    CookiesType["refreshToken"] = "refresh_token";
    CookiesType["role"] = "role";
    CookiesType["adminToken"] = "admin_token";
    CookiesType["adminRefreshToken"] = "admin_refresh_token";
})(CookiesType = exports.CookiesType || (exports.CookiesType = {}));
var Scope;
(function (Scope) {
    Scope["Preview"] = "preview";
    Scope["Access"] = "access";
})(Scope = exports.Scope || (exports.Scope = {}));
var RecurrenceRule;
(function (RecurrenceRule) {
    RecurrenceRule["daily"] = "daily";
    RecurrenceRule["hourly"] = "hourly";
    RecurrenceRule["off"] = "off";
})(RecurrenceRule = exports.RecurrenceRule || (exports.RecurrenceRule = {}));
var CheckResult;
(function (CheckResult) {
    CheckResult["failed"] = "failed";
    CheckResult["passed"] = "passed";
    CheckResult["timeouts"] = "timeouts";
    CheckResult["warning"] = "warning";
})(CheckResult = exports.CheckResult || (exports.CheckResult = {}));
var Status;
(function (Status) {
    Status["failed"] = "failed";
    Status["warnings"] = "warnings";
    Status["passed"] = "passed";
})(Status = exports.Status || (exports.Status = {}));
var StatusColors;
(function (StatusColors) {
    StatusColors["failed"] = "statusError";
    StatusColors["warnings"] = "statusWarning";
    StatusColors["passed"] = "statusOk";
})(StatusColors = exports.StatusColors || (exports.StatusColors = {}));
var Role;
(function (Role) {
    Role["admin"] = "admin";
    Role["user"] = "user";
})(Role = exports.Role || (exports.Role = {}));
var Difficulty;
(function (Difficulty) {
    Difficulty["Low"] = "low";
    Difficulty["Medium"] = "medium";
    Difficulty["High"] = "high";
})(Difficulty = exports.Difficulty || (exports.Difficulty = {}));
var Frequency;
(function (Frequency) {
    Frequency["Daily"] = "daily";
    Frequency["Hourly"] = "hourly";
})(Frequency = exports.Frequency || (exports.Frequency = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["Teaser"] = "teaser";
    UserStatus["Full"] = "full";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
//# sourceMappingURL=enums.js.map